import { DecodedValueMap, NumberParam, SetQuery } from 'use-query-params'
import { GlobalDialogFormsParams } from '@components/GlobalDialogForms'

export const WholesaleCartParams = {
  ...GlobalDialogFormsParams,
  editLinePk: NumberParam,
}

export type TWholesaleCartParams = DecodedValueMap<typeof WholesaleCartParams>
export type TWholesaleCartSetParams = SetQuery<typeof WholesaleCartParams>
